import type { Document, DocumentTemplate } from "@models";

export const resolveExplorerTemplatesForDevice = ({
  deviceId,
  orgId,
  templates,
}: {
  deviceId: string;
  orgId: string;
  templates: DocumentTemplate[];
}) => {
  const resolvedTemplates = new Map<string, DocumentTemplate>();

  templates
    .filter(
      (template) =>
        template.organizationId === null && template.deviceId === null
    )
    .forEach((template) => {
      resolvedTemplates.set(template.templateKey, template);
    });

  templates
    .filter(
      (template) =>
        template.organizationId === orgId && template.deviceId === null
    )
    .forEach((template) => {
      resolvedTemplates.set(template.templateKey, template);
    });

  templates
    .filter(
      (template) =>
        template.organizationId === orgId && template.deviceId === deviceId
    )
    .forEach((template) => {
      resolvedTemplates.set(template.templateKey, template);
    });

  return [...resolvedTemplates.values()];
};

export const filterExplorerDocumentsForDevice = ({
  deviceId,
  documents,
  includeOrgDocs,
}: {
  deviceId: string;
  documents: Document[];
  includeOrgDocs: boolean;
}) =>
  documents.filter(
    (document) =>
      document.deviceId === deviceId ||
      (includeOrgDocs && document.deviceId === null)
  );

export const coalesceInFlightRequests = <TArgs extends unknown[], TResult>(
  getKey: (...args: TArgs) => string,
  request: (...args: TArgs) => Promise<TResult>
) => {
  const inFlightRequests = new Map<string, Promise<TResult>>();

  return (...args: TArgs) => {
    const key = getKey(...args);
    const existingRequest = inFlightRequests.get(key);

    if (existingRequest) {
      return existingRequest;
    }

    const nextRequest = request(...args);
    inFlightRequests.set(key, nextRequest);

    const clearRequest = () => {
      if (inFlightRequests.get(key) === nextRequest) {
        inFlightRequests.delete(key);
      }
    };
    void nextRequest.then(clearRequest, clearRequest);

    return nextRequest;
  };
};
